import { createContext, ReactNode, useMemo } from 'react';

import { AppUser } from './menu';

// ****** Google Analytics
export interface GTagProviderProps {
  isGtmReady: boolean;
  user: AppUser;
  children?: ReactNode;
}

export const GTagContext = createContext<{ isGtmReady: boolean; user: AppUser }>({
  isGtmReady: false,
  user: {},
});

export const GTagProvider = ({ children, isGtmReady, user }: GTagProviderProps) => {
  const value = useMemo(() => ({ isGtmReady, user }), [isGtmReady, user]);
  return <GTagContext.Provider value={value}>{children}</GTagContext.Provider>;
};
